<div
  class="search-dropdown"
  [ngClass]="{
    open: shown && list !== undefined,
    small: size == 'small'
  }"
>
  <div class="search-dropdown__btn" (click)="show()">
    <span>{{ value }}</span>
  </div>
  <div class="search-dropdown__dropdown" *ngIf="shown">
    <input
      class="search-dropdown__dropdown__search"
      type="text"
      placeholder="Pesquisar"
      [(ngModel)]="keyword"
      (input)="search(keyword)"
      #input
    />
    <div class="search-dropdown__dropdown__scroller">
      <div
        class="search-dropdown__dropdown__item"
        *ngFor="let item of list"
        (click)="select(item)"
      >
        <!-- <div class="search-dropdown__dropdown__item__img"
          [style.background-image]="'url(data:image/jpg;base64,'+item[_img]+')'"></div> -->
        {{ item[_label] }}
      </div>
      <div class="search-dropdown__dropdown__msg" *ngIf="list?.length == 0">
        Não encontrado
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/shared/search-dropdown/search-dropdown.component.html